<template>
  <div>
    <el-card style="height:460px;">
      <div slot="header">
        <span>任务完成情况</span>
        <el-select
          @change="onPeriodChange"
          v-model="dtPeriod"
          placeholder="请选择"
          size="mini"
          class="top-selector"
        >
          <el-option
            v-for="period in dtPeriodList"
            :key="period.key"
            :label="period.text"
            :value="period.key"
          ></el-option>
        </el-select>
        <el-select
          @change="onTypeChange"
          v-model="dtType"
          placeholder="请选择"
          size="mini"
          class="top-selector"
        >
          <el-option
            v-for="type in dtTypeList"
            :key="type.key"
            :label="type.text"
            :value="type.key"
          ></el-option>
        </el-select>
      </div>
      <div id="taskStatCompleted" style="width:100%;height:365px;"></div>
    </el-card>
  </div>
</template>

<script>
import { GetTaskCompleteStatsByDate } from "@/api/modules/basicData/task.js";
let echarts = require("echarts");
export default {
  name: "TaskStatCompleted",
  data: function() {
    return {
      dtType: "0",
      dtPeriod: "0",
      dtTypeList: [
        { key: "0", text: "创建时间" },
        { key: "1", text: "接收时间" },
        { key: "2", text: "完成时间" }
      ],
      dtPeriodList: [
        { key: "0", text: "最近7天" },
        { key: "1", text: "最近15天" },
        { key: "2", text: "最近30天" },
        { key: "3", text: "最近6个月" },
        { key: "4", text: "最近1年" }
      ],
      request:{}
    };
  },
  methods: {
    draw(titles, values) {
      let dom = document.getElementById("taskStatCompleted");
      if(!dom){
        return;
      }
      let chart = echarts.init(dom);
      let option = {
        xAxis: {
          type: "category",
          data: titles
        },
        yAxis: {
          type: "value"
        },
        series: [
          {
            data: values,
            type: "line"
          }
        ]
      };
      chart.setOption(option);
    },
    refresh(request) {
      this.request=request;
      GetTaskCompleteStatsByDate({
        TimeType: this.dtType,
        TimeRange: this.dtPeriod,
        UserId: request.UserId,
        TaskIds: request.TaskIds || "",
        Paras: request.Paras || {},
        ServerCenterId: request.ServerCenterId || ""
      })
        .then(res => {
          if (res && res.length > 0) {
            let titles = res.map(stat => stat.Name.split("T")[0]);
            let values = res.map(stat => stat.Value);
            this.draw(titles, values);
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    onPeriodChange(period) {
      this.refresh(this.request);
    },
    onTypeChange(type) {
      this.refresh(this.request);
    }
  }
};
</script>

<style lang="less" scoped>
.top-selector {
  margin-top: -4px;
  margin-left: 12px;
  width: 100px;
  float: right;
}
</style>
